import { DataTable, DataTablePagination } from 'components/common'
import { getColumns } from 'components/logsExport/utils'
import { useQuery } from 'hooks'
import { useEffect, useMemo, useState } from 'react'
import { Helmet } from 'react-helmet'
import { useLocation } from 'react-router-dom'
import { fetchFreshReportExportLogs } from 'utils/api/freshReportApi'
import { calculateOffset } from 'utils/helpers/pagination'

/**
 * Export logs for Fresh report exports only.
 *
 * A page of its own rather than a section of Fresh Reports: the files land
 * minutes after the export is queued, so the admin comes back to this later
 * rather than watching for it on the page they exported from.
 *
 * Columns are reused from the shared Export Logs page so a file reads the
 * same wherever it is listed. There is no filter form - the server already
 * scopes this to the Fresh module, which is the only filter that matters
 * here.
 */
const FreshExportLogsPage = () => {
  const [response, setResponse] = useState<any>({})
  const [offset, setOffset] = useState<number>(0)

  const { search } = useLocation()
  const { getAllQueries } = useQuery()

  const columns = useMemo(() => getColumns(offset), [offset])

  const getLogs = async () => {
    const queries = getAllQueries()

    try {
      const { data } = await fetchFreshReportExportLogs({
        limit: queries.limit || 10,
        page: queries.page || 1,
      })
      setOffset(calculateOffset(data))
      setResponse(data)
    } catch {
      setResponse({ docs: [] })
    }
  }

  useEffect(() => {
    getLogs()
  }, [search])

  return (
    <>
      <Helmet>
        <title>GAG Aggregator | Fresh Export Logs</title>
      </Helmet>

      <div className="mb-2">
        <h3 className="title">Fresh Export Logs</h3>
        <p className="mt-1 text-sm text-gray-500">
          Files produced by Export on the Fresh Reports page. A large export
          takes a few minutes to appear here.
        </p>
      </div>

      <DataTable columns={columns} rows={response?.docs} identifier="_id" />

      <DataTablePagination
        currentPage={response?.page}
        totalPages={response?.totalPages}
        hasNextPage={response?.hasNextPage}
        hasPrevPage={response?.hasPrevPage}
        limit={response?.limit}
        nextPage={response?.nextPage}
        prevPage={response?.prevPage}
      />
    </>
  )
}

export default FreshExportLogsPage
